import {
  REPATRIATIONS_TRANSACTIONS_CONFIRM_REQUEST,
  REPATRIATIONS_TRANSACTIONS_CONFIRM_SUCCESS,
  REPATRIATIONS_TRANSACTIONS_CONFIRM_FAILURE,
} from './types/RepatriationsTransactionsConfirmActionsTypes';

export function postRepatriationsTransactionsConfirmRequestActionCreator(context,
  newDescription,
  newPlannedArrivalDateTime,
  newQuantity,
  newTransactionId) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_CONFIRM_REQUEST,
    payload: {
      appContext: context,
      params: {
        description: newDescription,
        plannedArrivalDateTime: newPlannedArrivalDateTime,
        quantityConfirmed: newQuantity,
        transactionId: newTransactionId,
      },
    },
  };
}

export function postRepatriationsTransactionsConfirmSuccessActionCreator(data) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_CONFIRM_SUCCESS,
    payload: data,
  };
}

export function postRepatriationsTransactionsConfirmFailureActionCreator(error) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_CONFIRM_FAILURE,
    payload: error,
    error: true,
  };
}
